/*
File: MonthlyBill 当月累计使用明细
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-18
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useAction } from '@/hooks/useAction'
import PaginationTable from '@cmps/PaginationTable/PaginationTable'
import { Table, Modal, Button } from 'antd'
import * as R from 'ramda'
import { format } from 'date-fns/fp'

import {
  profileCurrentGoodsBackPaySummary,
  profileCurrentGoodsBackPayDetail,
} from '@/api/api'

const log = R.tap(console.log)

const formatDate = R.compose(
  R.converge(
    R.unapply(R.join('-')),
    [
      R.slice(0, 4),
      R.slice(4, 6),
    ],
  ),
  R.toString,
)

const detailColumns = [
  {
    title: '日期',
    dataIndex: 'statisticTime',
    render: value => <span>{ format('yyyy-MM-dd', parseInt(value, 10) * 1000) }</span>,
  },
  {
    title: '当日收益(金豆)',
    dataIndex: 'todayData',
  },
  {
    title: '累积收益(金豆)',
    dataIndex: 'latestTotalData',
  },
  {
    title: '对应累积金额(虎牙币)',
    dataIndex: 'latestExpense',
    render: (value, row) => <span>{ parseInt(R.min(value, R.defaultTo(Infinity, row.maxFee)), 10) / 100 }</span>,
  },
]

function MonthlyBill() {
  const [detailState, performGetDetail] = useAction(profileCurrentGoodsBackPayDetail)

  const [isDetailVisible, toggleDetail] = useState(false)

  const [currentRecordForDetail, setCurrentRecord] = useState({})

  const handleClickDetail = useCallback(record => {
    console.log(record)

    performGetDetail({
      goodsUuid: record.goodsUuid,
    })
    setCurrentRecord(record)

    toggleDetail(true)
  }, [])

  const columns = useMemo(() => [
    {
      title: '月份',
      dataIndex: 'statementDate',
      render: text => <span>{ formatDate(text) }</span>,
    },
    {
      title: '小程序',
      dataIndex: 'extName',
    },
    {
      title: '商品',
      dataIndex: 'goodsName',
    },
    // {
    // title: '收费维度',
    // dataIndex: 'goodsFeeType',
    // render: (type) => <span>{ type === 3 ? '直接付费' : '礼物收益收费' }</span>,
    // },
    {
      title: '累积计数(金豆)',
      dataIndex: 'latestTotalData',
    },
    {
      title: '累计费用(虎牙币)',
      dataIndex: 'latestExpense',
      render: (value, row) => <span>{ parseInt(R.min(value, R.defaultTo(Infinity, row.maxFee)), 10) / 100 }</span>,
    },
    {
      title: '操作',
      render: (text, record) => (
        <div>
          <Button size="small" onClick={() => handleClickDetail(record)}>查看详情</Button>
        </div>
      ),
    },
  ])

  return (
    <div>
      <PaginationTable
        fetcher={profileCurrentGoodsBackPaySummary}
        columns={columns}
      />
      <Modal
        title="使用明细"
        visible={isDetailVisible}
        onOk={() => toggleDetail(false)}
        onCancel={() => toggleDetail(false)}
        footer={null}
        key={R.prop('goodsUuid', currentRecordForDetail)}
        bodyStyle={{padding: '0'}}
        width={560}
      >
        <Table
          loading={R.prop('isLoading', detailState)}
          columns={detailColumns}
          dataSource={R.propOr([], 'respData', detailState)}
          pagination={false}
        />
      </Modal>
    </div>
  )
}


export default MonthlyBill
